import { Box, Stack } from '@mui/material';
import type { ReactNode } from 'react';

import Text, { type Size } from '../Text';

interface Props {
  attributes: {
    [key: string]: string | number | boolean | null | undefined | ReactNode;
  };

  size?: Size;
}

export default function AttributeList({ size, attributes }: Props) {
  return (
    <Stack>
      {Object.entries(attributes).map(([key, value]) => {
        return (
          <Stack
            key={key}
            direction="row"
            sx={{
              gap: 1,
            }}
          >
            <Text
              component="span"
              size={size}
            >
              {key}
            </Text>
            <Text
              component="span"
              color="black"
              size={size}
            >
              {value}
            </Text>
          </Stack>
        );
      })}
    </Stack>
  );
}
